import React from "react";
import { useTranslation } from "react-i18next";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import { LiveTrainingClubLogo } from "./LiveTrainingClubLogo";

function formatRemaining(ms) {
  const totalSec = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  if (h > 0) return `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  return `${m}:${String(s).padStart(2, "0")}`;
}

export function LiveTrainingWaitingRoom({ remainingMs, tableInfo, user = null }) {
  const { t } = useTranslation();

  return (
    <div className="lt-waiting">
      <div className="lt-waiting__pulse" aria-hidden />
      <LiveTrainingClubLogo
        user={user}
        size="lg"
        className="lt-waiting__club-logo"
        showName
      />
      <HourglassTopIcon className="lt-waiting__icon" />
      <h2 className="lt-waiting__title">{t("liveTrainingWaiting")}</h2>
      <p className="lt-waiting__hint">{t("liveTrainingWaitingHint")}</p>
      {remainingMs > 0 ? (
        <div className="lt-waiting__countdown">
          <span className="lt-waiting__countdown-label">{t("liveTrainingSlotRemaining")}</span>
          <span className="lt-waiting__countdown-value">{formatRemaining(remainingMs)}</span>
        </div>
      ) : null}
      {tableInfo ? (
        <div className="lt-waiting__table-card">
          <span className="lt-waiting__table-label">{t("table")}</span>
          <span className="lt-waiting__table-num">{tableInfo}</span>
        </div>
      ) : null}
    </div>
  );
}

export default LiveTrainingWaitingRoom;
